export default function Home4() {
    return (
      <div className="min-h-screen bg-indigo-900 px-4 py-8 md:px-8 lg:px-16">
        <div className="mx-auto max-w-7xl">
          {/* Main Header */}
          <div className="mb-12 text-center">
            <h1 
              className="leading-tight"
              style={{
                fontFamily: '"Futura Bold", Sans-serif',
                fontSize: '100px',
                fontWeight: 700,
                lineHeight: '100px',
                color: '#FFFFFF'
              }}
            >
              Uber Sexual Assault Litigation - <span className="text-cyan-400">Recent Updates</span>
            </h1>
          </div>
  
          {/* First Update Section */}
          <div className="mb-12">
            <h2 
              className="mb-6 leading-tight"
              style={{
                fontFamily: '"Futura Bold", Sans-serif',
                fontSize: '25px',
                fontWeight: 700,
                lineHeight: '25px',
                color: '#EBFF02'
              }}
            >
              August 12, 2025: Two New Wave 1 Bellwether Cases Confirmed
            </h2>
  
            <div className="space-y-4 leading-relaxed">
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                The federal judge presiding over the Uber sexual assault multi-district litigation finalized selections
                for two new Trial Wave 1 bellwether cases this week. New bellwether selections were necessary since one
                original Wave 1 case was dismissed following a motion by Uber, and the other case failed to meet discovery
                deadlines. The newly selected Wave 1 cases are as follows:
              </p>
  
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                24-cv-4900 – North Carolina. The Plaintiff lives in Franklinton, North Carolina, and alleges they were
                touched on a non-sexual body part by an Uber driver in Wake County, North Carolina, on March 26, 2019.
              </p>
  
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                24-cv-4889 – North Carolina. The Plaintiff lives in Charlotte, North Carolina, and alleges they were
                touched on a non-sexual body part by an Uber driver in Mecklenburg County, North Carolina, on March 20,
                2021.
              </p>
  
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                Both new Wave 1 cases originated in North Carolina, were chosen by Uber, and involve "touching of a
                non-sexual body part." The original two cases involved sexual harassment and touching of a sexual body
                part in Texas and Illinois. Trials for the first wave of bellwether cases are set to begin in early
                December, and the judge also ordered the parties to begin selecting cases for Trial Wave 2.
              </p>
            </div>
          </div>
  
          {/* Second Update Section */}
          <div className="mb-12">
            <h2 
              className="mb-6 leading-tight"
              style={{
                fontFamily: '"Futura Bold", Sans-serif',
                fontSize: '25px',
                fontWeight: 700,
                lineHeight: '25px',
                color: '#EBFF02'
              }}
            >
              August 8, 2025: Judge Dismisses 29 Cases for Noncompliance
            </h2>
  
            <div className="space-y-4 leading-relaxed">
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                On August 7, U.S. District Judge Charles R. Breyer again reviewed Uber's request to dismiss a number of
                cases for failing to submit completed plaintiff fact sheets. Because the plaintiffs did not comply with
                discovery orders, the judge dismissed 29 cases without prejudice, meaning the cases could be refiled in
                the future. However, refilings are not likely, as the plaintiffs who have not yet filed fact sheets are
                ones whom law firms have been unable to reach for months.
              </p>
  
              <p 
                style={{
                  fontSize: '21px',
                  lineHeight: '35px',
                  fontFamily: '"Avenir Book", sans-serif',
                  fontWeight: 400,
                  color: '#FFFFFF'
                }}
              >
                Uber originally requested the dismissal of nearly 100 cases in May for failing to submit fact sheets by
                the original deadline in April. The fact sheets have been an ongoing battle for the firms managing the
                inactive cases, though many of the original 100 cases have now filed the necessary information to remain
                active.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
  